import React from 'react';
import { useNavigate } from 'react-router-dom';

const quickLinks = [
  ['/cockpit', 'Cockpit', 'Trends, Warnungen, Budgets, Vertragsradar und Geldfresser auf einen Blick.'],
  ['/review', 'Finanz-Review', 'Zentrale Inbox für offene Entscheidungen aus Geldfressern, Verträgen, Budgets und Anomalien.'],
  ['/banking', 'Bank-Sync', 'ING/PSD2-Anbindung vorbereiten und Sync-Protokoll prüfen.'],
  ['/budgets', 'Budget-Ziele', 'Monatslimits je Kategorie setzen und Ampeln beobachten.'],
  ['/contracts', 'Abo- und Vertragsradar', 'Wiederkehrende Zahlungen erkennen, behalten, prüfen oder kündigen.'],
  ['/anomalies', 'Anomalie-Radar', 'Neue Empfänger, Ausreißer, Dubletten und Kategorie-Sprünge prüfen.'],
  ['/geldfresser', 'Geldfresser prüfen', 'Vorschläge sichten, sammeln, markieren und bei Bedarf rückgängig machen.'],
  ['/abschluss', 'Monatsabschluss', 'Geführter Abschluss mit Budgets, Verträgen, Sparpotenzial und Snapshots.'],
  ['/reports', 'Berichte', 'Monatsbericht, Jahresbericht, Druckansicht, Snapshots und Exporte.'],
  ['/rules', 'Regelcenter', 'Kategorisierungsregeln testen, anwenden und rückgängig machen.'],
  ['/imports', 'Datei-Center', 'Importe prüfen, Details ansehen, exportieren und sicher zurückrollen.'],
  ['/system', 'Systemkonsole', 'Healthcheck, Selbstcheck, Reparatur und Statusbericht.'],
];

const workflows = [
  ['Monatscheck', 'Cockpit ansehen, Budget-Ampeln prüfen, Vertragsradar öffnen, Bericht ansehen, Snapshot speichern.'],
  ['Geldfresser bearbeiten', 'Geldfresser prüfen, Top-Kandidaten markieren, Auswahl speichern, Aktionsplan im Cockpit kontrollieren.'],
  ['Verträge prüfen', 'Abo- und Vertragsradar öffnen, Kandidaten als behalten/prüfen/kündigen markieren, Details ansehen.'],
  ['Neue Daten', 'Datei importieren oder Bank-Sync vorbereiten, im Datei-Center Details prüfen, danach Regeln und Budgets kontrollieren.'],
];

const checkpoints = [
  'Health muss ok sein und Uploads müssen schreibbar sein.',
  'Änderungen mit Risiko haben Undo oder geschützte Rücknahmewege.',
  'Berichte und Snapshots sind lesend, bis du bewusst einen Snapshot speicherst.',
  'Budget- und Vertragsdaten sind Statusdaten; Buchungen werden dadurch nicht verändert.',
];

export default function HelpPage() {
  const nav = useNavigate();
  return (
    <div className="help-page">
      <section className="hero-panel">
        <p className="eyebrow">Arbeitsleitfaden</p>
        <h2>Schnellstart für die Finanzanalyse</h2>
        <p>
          Alle wichtigen Werkzeuge sind hier als Buttons gesammelt. Die gleiche
          Navigation findest du unten als Hauptnavigation und oben bei den
          wichtigsten Schnellzugriffen.
        </p>
      </section>

      <section className="workflow-grid">
        {quickLinks.map(([path, title, text]) => (
          <button key={path} className="workflow-card" onClick={() => nav(path)} style={{ textAlign: 'left', cursor: 'pointer' }}>
            <h3>{title}</h3>
            <p>{text}</p>
            <strong style={{ color: '#064734', fontSize: '12px' }}>Öffnen: {path}</strong>
          </button>
        ))}
      </section>

      <section className="workflow-grid">
        {workflows.map(([title, text]) => (
          <article className="workflow-card" key={title}>
            <h3>{title}</h3>
            <p>{text}</p>
          </article>
        ))}
      </section>

      <section className="check-panel">
        <h3>Stabile Nutzung</h3>
        <ul>
          {checkpoints.map(item => <li key={item}>{item}</li>)}
        </ul>
      </section>
    </div>
  );
}
